<template>
  <section>
    <div
      v-if="image.original"
      class="form-section form-section--img"
      :class="{ invert: background === 'dark' || background === 'dark-with-logo' }"
      :style="backgroundStylesImg[background]"
    >
      <div v-if="isFirst && breadcrumbs?.length" class="wrapper wrapper--breadcrumbs">
        <CBreadcrumbs :parent-sections="breadcrumbs" :current-page-name="pageHeader" />
      </div>
      <div class="wrapper">
        <div class="form-section__container">
          <UIPictureTag
            class="form-section__picture"
            :image-original="`${url}${image.source}`"
            :image-seo="imageSeo"
            :image-webp="`${url}${image.webp}`"
            :is-visible="isFirst"
            :fetch-priority="isFirst ? 'high' : undefined"
          />
          <div class="form-section__right">
            <div class="form-section__content">
              <h2 v-if="title" class="form-section__title">{{ title }}</h2>
              <CTextBlock v-if="text" class="form-section__text" :text="text" />
              <UIButton variant="primary" size="xl" @click="openFeedback">
                Записаться на приём
              </UIButton>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-else
      class="form-section"
      :class="{ invert: background === 'dark' || background === 'dark-with-logo' }"
      :style="backgroundStyles[background]"
    >
      <div v-if="isFirst && breadcrumbs?.length" class="wrapper wrapper--breadcrumbs">
        <CBreadcrumbs :parent-sections="breadcrumbs" :current-page-name="pageHeader" />
      </div>
      <div class="wrapper">
        <div class="form-section__content">
          <h2 v-if="title" class="form-section__title">{{ title }}</h2>
          <CTextBlock class="form-section__text" :text="text" />
          <UIButton variant="primary" size="xl" @click="openFeedback">
            Записаться на приём
          </UIButton>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import CTextBlock from '~/components/blocks/textBlock/CTextBlock.vue';
import type { BlockTextFormBackground, FormModel, ImageItem, ImageSEO } from '~/types/pages';
import './styles.scss';
import bgDarkImg from '~/assets/images/bg-dark-img.webp';
import bgLightImg from '~/assets/images/bg-light-img.webp';
import bgLightenImg from '~/assets/images/bg-lighten-img.webp';
import CBreadcrumbs from '~/components/breadcrumbs/CBreadcrumbs.vue';
import type { ClientBreadcrumbsItem } from '~/types/client/pages';
import UIPictureTag from '~/components/UI/picture/UIPictureTag.vue';
import UIButton from '~/components/UI/button/UIButton.vue';
import { useRuntimeConfig } from '#imports';
import { useFeedbackWidget } from '~/composables/useFeedbackWidget';

interface Props {
  title: string;
  text: string;
  form: FormModel;
  formTitle: string;
  background: BlockTextFormBackground;
  isFirst: boolean;
  breadcrumbs?: ClientBreadcrumbsItem[];
  pageHeader?: string;
  image: ImageItem;
  imageSeo: ImageSEO;
}

defineProps<Props>();

const { open: openFeedback } = useFeedbackWidget();


const url = useRuntimeConfig().public.siteUrl;

const backgroundStyles: Record<BlockTextFormBackground, Record<string, string>> = {
  dark: {
    backgroundColor: '#00233B',
  },
  'dark-with-logo': {
    backgroundColor: '#00233B',
    '--pattern-color': '#D3D3D3',
    '--pattern-opacity': '0.05',
  },
  light: {
    backgroundColor: '#EDE5D8',
    '--pattern-color': '#DABC8E',
    '--pattern-opacity': '0.25',
  },
  lighten: {
    backgroundColor: '#F5F5F5',
    '--pattern-color': '#DABC8E',
    '--pattern-opacity': '0.15',
  },
};

const backgroundStylesImg: Record<
  BlockTextFormBackground,
  { backgroundColor: string; backgroundImage?: string }
> = {
  dark: {
    backgroundColor: '#00233B',
  },
  'dark-with-logo': {
    backgroundColor: '#00233B',
    backgroundImage: `url(${bgDarkImg})`,
  },
  light: {
    backgroundColor: '#EDE5D8',
    backgroundImage: `url(${bgLightImg})`,
  },
  lighten: {
    backgroundColor: '#F5F5F5',
    backgroundImage: `url(${bgLightenImg})`,
  },
};
</script>

<style scoped></style>
